export const formatEmiratesId = (value: string) => {
  return value.replace(/(.{3})(.{4})(.{7})(.{1})/, '$1-$2-$3-$4')
}
